/**
 * Variant Product Badge Handler
 * Updates product badges (sold out, sale) based on specific variant availability
 * for the variant-as-product display in product-list section
 */

(function () {
    function updateVariantBadges() {
        // Find all product grid items with variant data
        const productItems = document.querySelectorAll('[data-variant-available]');

        productItems.forEach(item => {
            const isAvailable = item.dataset.variantAvailable === 'true';
            const price = parseFloat(item.dataset.variantPrice);
            const comparePrice = parseFloat(item.dataset.variantComparePrice);

            // Find the badge container
            const badgeContainer = item.querySelector('.product-badges');
            if (!badgeContainer) return;

            // Find existing badge
            let badge = badgeContainer.querySelector('.product-badges__badge');

            // Determine what badge to show
            const isOnSale = comparePrice && comparePrice > price;

            if (!isAvailable) {
                // Show sold out badge
                if (!badge) {
                    badge = document.createElement('div');
                    badge.className = 'product-badges__badge product-badges__badge--rectangle';
                    badgeContainer.appendChild(badge);
                }

                // Get the color scheme class (check for existing pattern or use data attribute if available)
                const existingClasses = badge.className;
                if (!existingClasses.includes('color-')) {
                    // Try to extract color scheme from theme settings or use a default
                    const colorScheme = getColorSchemeFromSettings('sold_out');
                    if (colorScheme) {
                        badge.classList.add(colorScheme);
                    }
                }

                badge.textContent = getSoldOutText();
            } else if (isOnSale) {
                // Show sale badge  
                if (!badge) {
                    badge = document.createElement('div');
                    badge.className = 'product-badges__badge product-badges__badge--rectangle';
                    badgeContainer.appendChild(badge);
                }

                const colorScheme = getColorSchemeFromSettings('sale');
                if (colorScheme && !badge.className.includes('color-')) {
                    badge.classList.add(colorScheme);
                }

                badge.textContent = getSaleText();
            } else {
                // No badge needed, remove if exists
                if (badge) {
                    badge.remove();
                }
            }
        });
    }

    function getColorSchemeFromSettings(type) {
        // Try to get color scheme from existing badges
        const existingBadge = document.querySelector('.product-badges__badge[class*="color-"]');
        if (existingBadge) {
            const match = existingBadge.className.match(/color-scheme-\d+/);
            if (match) {
                return match[0];
            }
        }
        return '';
    }

    function getSoldOutText() {
        // Try to get translation from page
        const existingBadge = Array.from(document.querySelectorAll('.product-badges__badge'))
            .find(b => b.textContent.toLowerCase().includes('sold') || b.textContent.toLowerCase().includes('out'));

        return existingBadge ? existingBadge.textContent : 'Sold out';
    }

    function getSaleText() {
        const existingBadge = Array.from(document.querySelectorAll('.product-badges__badge'))
            .find(b => b.textContent.toLowerCase().includes('sale'));

        return existingBadge ? existingBadge.textContent : 'Sale';
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateVariantBadges);
    } else {
        updateVariantBadges();
    }
})();
